
import ContactForm from './ContactForm';

export default function Footer() {
  return (
    <footer className="bg-gray-900 text-white">
      {/* Section Contact */}
      <section id="contact" className="py-16 border-b border-gray-800">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold mb-4">Contactez-Nous</h2>
            <p className="text-xl text-gray-300">
              Une question ? Un projet ? N'hésitez pas à nous contacter
            </p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
            {/* Informations de contact */}
            <div>
              <h3 className="text-2xl font-semibold mb-6">Nos Coordonnées</h3>
              
              <div className="space-y-6">
                <div className="flex items-start">
                  <div className="w-12 h-12 bg-blue-600 rounded-full flex items-center justify-center mr-4 flex-shrink-0">
                    <i className="ri-phone-line text-xl"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold mb-1">Téléphone</h4>
                    <p className="text-gray-300">438 408 1200</p>
                    <p className="text-sm text-gray-400">Lun-Ven: 8h-19h | Sam: 9h-17h</p>
                  </div>
                </div>

                <div className="flex items-start">
                  <div className="w-12 h-12 bg-blue-600 rounded-full flex items-center justify-center mr-4 flex-shrink-0">
                    <i className="ri-mail-line text-xl"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold mb-1">Email</h4>
                    <p className="text-gray-300">info@netyxpro.com</p>
                    <p className="text-sm text-gray-400">Réponse sous 2h en moyenne</p>
                  </div>
                </div>

                <div className="flex items-start">
                  <div className="w-12 h-12 bg-blue-600 rounded-full flex items-center justify-center mr-4 flex-shrink-0">
                    <i className="ri-map-pin-line text-xl"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold mb-1">Zone d'Intervention</h4>
                    <p className="text-gray-300">Montréal, Québec, Canada</p>
                    <p className="text-sm text-gray-400">Devis gratuit sur place</p>
                  </div>
                </div>

                <div className="flex items-start">
                  <div className="w-12 h-12 bg-blue-600 rounded-full flex items-center justify-center mr-4 flex-shrink-0">
                    <i className="ri-time-line text-xl"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold mb-1">Urgences</h4>
                    <p className="text-gray-300">438 408 1200</p>
                    <p className="text-sm text-gray-400">Disponible 24h/24</p>
                  </div>
                </div>
              </div>

              <div className="mt-8">
                <h4 className="font-semibold mb-4">Suivez-nous</h4>
                <div className="flex space-x-4">
                  <a href="#" className="w-10 h-10 bg-blue-600 rounded-full flex items-center justify-center hover:bg-blue-700 transition-colors cursor-pointer">
                    <i className="ri-facebook-fill"></i>
                  </a>
                  <a href="#" className="w-10 h-10 bg-blue-600 rounded-full flex items-center justify-center hover:bg-blue-700 transition-colors cursor-pointer">
                    <i className="ri-instagram-line"></i>
                  </a>
                  <a href="#" className="w-10 h-10 bg-blue-600 rounded-full flex items-center justify-center hover:bg-blue-700 transition-colors cursor-pointer">
                    <i className="ri-linkedin-fill"></i>
                  </a>
                  <a href="#" className="w-10 h-10 bg-blue-600 rounded-full flex items-center justify-center hover:bg-blue-700 transition-colors cursor-pointer">
                    <i className="ri-twitter-fill"></i>
                  </a>
                </div>
              </div>
            </div>

            {/* Formulaire de contact */}
            <div>
              <h3 className="text-2xl font-semibold mb-6">Demande de Devis</h3>
              <ContactForm />
            </div>
          </div>
        </div>
      </section>

      {/* Footer principal */}
      <div className="py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
            <div className="md:col-span-1">
              <div className="flex items-center mb-4">
                <img 
                  src="/logo_netyxpro.jpg"
                  alt="NetyxPro Logo"
                  className="h-12 w-auto object-contain"
                />
              </div>
              <p className="text-gray-300 mb-4">
                Votre partenaire de confiance pour tous vos besoins d'entretien 
                et de services à domicile ou en entreprise à Montréal.
              </p>
              <div className="flex items-center text-sm text-gray-400">
                <i className="ri-shield-check-line mr-2"></i>
                Assuré et certifié
              </div>
            </div>

            <div>
              <h4 className="font-semibold mb-4">Services Particuliers</h4>
              <ul className="space-y-2 text-gray-300">
                <li><a href="#residential" className="hover:text-white transition-colors cursor-pointer">Entretien résidentiel</a></li>
                <li><a href="#laundry" className="hover:text-white transition-colors cursor-pointer">Lessive & repassage</a></li>
                <li><a href="#delivery" className="hover:text-white transition-colors cursor-pointer">Courses & livraison</a></li>
                <li><a href="#contact" className="hover:text-white transition-colors cursor-pointer">Devis gratuit</a></li>
              </ul>
            </div>

            <div>
              <h4 className="font-semibold mb-4">Services Entreprises</h4>
              <ul className="space-y-2 text-gray-300">
                <li><a href="#commercial" className="hover:text-white transition-colors cursor-pointer">Nettoyage commercial</a></li>
                <li><a href="#commercial" className="hover:text-white transition-colors cursor-pointer">Bureaux & espaces de travail</a></li>
                <li><a href="#commercial" className="hover:text-white transition-colors cursor-pointer">Désinfection professionnelle</a></li>
                <li><a href="#delivery" className="hover:text-white transition-colors cursor-pointer">Livraison entreprise</a></li>
              </ul>
            </div>

            <div>
              <h4 className="font-semibold mb-4">Informations</h4>
              <ul className="space-y-2 text-gray-300">
                <li><a href="#" className="hover:text-white transition-colors cursor-pointer">À propos</a></li>
                <li><a href="#" className="hover:text-white transition-colors cursor-pointer">Nos garanties</a></li>
                <li><a href="#" className="hover:text-white transition-colors cursor-pointer">Tarifs</a></li>
                <li><a href="#" className="hover:text-white transition-colors cursor-pointer">Recrutement</a></li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      {/* Copyright */}
      <div className="border-t border-gray-800 py-6">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-gray-400 text-sm">
              © 2024 NetyxPro. Tous droits réservés.
            </p>
            <div className="flex space-x-6 mt-4 md:mt-0">
              <a href="#" className="text-gray-400 hover:text-white text-sm transition-colors cursor-pointer">
                Mentions légales
              </a>
              <a href="#" className="text-gray-400 hover:text-white text-sm transition-colors cursor-pointer">
                Confidentialité
              </a>
              <a href="#" className="text-gray-400 hover:text-white text-sm transition-colors cursor-pointer">
                CGV
              </a>
              <a href="https://readdy.ai/?origin=logo" className="text-gray-400 hover:text-white text-sm transition-colors cursor-pointer">
                Made with Readdy
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}